/**
 * Markdown, in the two places it actually appears.
 *
 * `react-markdown` + `remark-gfm` are kept for exactly these: **E2's notes are markdown whose first
 * line is the heading**, and **a wake's final reply is markdown**. Nothing else in the console
 * renders markdown, and nothing here is a general renderer.
 *
 * The note's first line is dropped when it is the heading the panel already shows, so the heading is
 * not printed twice — that is `_heading()` in utils/events.py, on this side.
 */

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ text, className }: { text: string; className?: string }) {
  return (
    <div className={className ?? "note__md"}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  );
}

/** A note's heading: its markdown's first line, with the hashes off. */
export function headingOf(note: string): string {
  return (note ?? "").trim().split("\n", 1)[0].replace(/^#+/, "").trim();
}

/** The note without the heading line, for when the panel draws the heading itself. */
export function bodyOf(note: string): string {
  const lines = (note ?? "").trim().split("\n");
  return lines.slice(1).join("\n").trim();
}
